export enum ACCOMMODATIONS_DIALOGS {
  VENUE_DIALOG = 'venueDialog',
  DATES_DIALOG = 'datesDialog',
  ACCOMMODATION_TOUR_TOOLTIP = 'accommodationTourTooltip',
  AI_RECOMMENDATIONS_FEEDBACK = 'aiRecommendationsFeedbackDialog',
  STAY_AREAS_TOOLTIP = 'stayAreasTooltip',
  EXPANDED_MAP_ANNOUNCEMENT = 'expandedMapAnnouncementDialog',
}
